module.exports = __webpack_public_path__ + "media/images/icons/flags/FK-074c842b2ad35ba64cf18bb6e0cca852.svg";